import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticStrongAuthRepository } from './AgnosticStrongAuthRepository'
import { createAgnosticHttpClient } from './createAgnosticHttpClient'

export function createAgnosticStrongAuthRepository() {
  return new AgnosticStrongAuthRepository({
    storage: new LocalStorageClient(),
    httpClient: createAgnosticHttpClient(),
  })
}
